import Control from "../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROServicePersonne = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig } = useRCPROQuestion({
    company,
  });
  return (
    <div>
      <Control
        label={inputsConfig.servicesPersonnePrestationsProposees.label}
        type="checkBtnList"
        name="servicesPersonnePrestationsProposees"
        value={company.RCPRO.servicesPersonnePrestationsProposees}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.servicesPersonnePrestationsProposees.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles.</>}
      />
      {company.RCPRO.servicesPersonnePrestationsProposees.includes(4) && (
        <Control
          label={inputsConfig.servicesPersonneAutrePrestation.label}
          type="text"
          name="servicesPersonneAutrePrestation"
          value={company.RCPRO.servicesPersonneAutrePrestation}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          onBlur={onBlur}
          required
        />
      )}
      <Control
        label={inputsConfig.servicesPersonneAgrementSpecifique.label}
        type="btnList"
        name="servicesPersonneAgrementSpecifique"
        value={company.RCPRO.servicesPersonneAgrementSpecifique}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.servicesPersonneAgrementSpecifique.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPROServicePersonne;
